import React, { Component } from "react";
import { Link } from "react-router-dom";

//Styles
import styles from "./navbarOnboarding.module.css";

//Material Ui Icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

class NavbarOnboarding extends Component {
  render() {
    const { name, backButton } = this.props;

    return (
      <div className={styles.container}>
        <div>
          {backButton && (
            <Link to="/" className={styles.backButton}>
              <ArrowBackIcon />
            </Link>
          )}
        </div>

        <span>{name}</span>
      </div>
    );
  }
}
export default NavbarOnboarding;
